/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { DeleteProjectsProjectidOptions, DeleteProjectsProjectidStatus204, DeleteProjectsProjectidStatus400, DeleteProjectsProjectidStatus401, DeleteProjectsProjectidStatus404, DeleteProjectsProjectidStatus500 } from '../types/DeleteProjectsProjectid'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { deleteProjectsProjectid } from '../clients/deleteProjectsProjectid'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const deleteProjectsProjectidMutationKey = () => [{ url: '/projects/:projectId' }] as const

export function deleteProjectsProjectidMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = deleteProjectsProjectidMutationKey()
  return mutationOptions<DeleteProjectsProjectidStatus204, ResponseErrorConfig<DeleteProjectsProjectidStatus400 | DeleteProjectsProjectidStatus401 | DeleteProjectsProjectidStatus404 | DeleteProjectsProjectidStatus500>, DeleteProjectsProjectidOptions, TContext>({
    mutationKey,
    mutationFn: async({ path }) => {
      return deleteProjectsProjectid({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * {@link /projects/:projectId}
 */
export function useDeleteProjectsProjectid<TContext>(options: {
  mutation?: UseMutationOptions<DeleteProjectsProjectidStatus204, ResponseErrorConfig<DeleteProjectsProjectidStatus400 | DeleteProjectsProjectidStatus401 | DeleteProjectsProjectidStatus404 | DeleteProjectsProjectidStatus500>, DeleteProjectsProjectidOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? deleteProjectsProjectidMutationKey()

  const baseOptions = deleteProjectsProjectidMutationOptions(config) as UseMutationOptions<DeleteProjectsProjectidStatus204, ResponseErrorConfig<DeleteProjectsProjectidStatus400 | DeleteProjectsProjectidStatus401 | DeleteProjectsProjectidStatus404 | DeleteProjectsProjectidStatus500>, DeleteProjectsProjectidOptions, TContext>

  return useMutation<DeleteProjectsProjectidStatus204, ResponseErrorConfig<DeleteProjectsProjectidStatus400 | DeleteProjectsProjectidStatus401 | DeleteProjectsProjectidStatus404 | DeleteProjectsProjectidStatus500>, DeleteProjectsProjectidOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<DeleteProjectsProjectidStatus204, ResponseErrorConfig<DeleteProjectsProjectidStatus400 | DeleteProjectsProjectidStatus401 | DeleteProjectsProjectidStatus404 | DeleteProjectsProjectidStatus500>, DeleteProjectsProjectidOptions, TContext>
}
